import { render, staticRenderFns } from "./InactiveChannelCard.vue?vue&type=template&id=4d8d42d4&scoped=true"
import script from "./InactiveChannelCard.vue?vue&type=script&lang=js"
export * from "./InactiveChannelCard.vue?vue&type=script&lang=js"
import style0 from "./InactiveChannelCard.vue?vue&type=style&index=0&id=4d8d42d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d42d4",
  null
  
)

export default component.exports